<template>
  <Header />
  <HomeCarousel />
  <!-- <img alt="Vue logo" src="./../../assets/logo.png" /> -->
  <!-- <HelloWorld msg="Welcome to Your Vue.js + TypeScript App" /> -->  
  <!-- <section class="sect"  style="display:none">
    <div class="sectTitle">社區故事</div>
    <div class="blog">
      <a class="item" :key="idx" v-for="(row, idx) in blog" href="">
        <div class="thumbnail" :style="setThumbnail(row.thumbnail)"></div>
        <div class="tit">{{row.tit}}</div>
        <div class="brief" v-html="setBrief(row.brief)"></div>
      </a>
    </div>
  </section>
  <section class="sect sectConcept"  style="display:none">
    <div class="concept">
      <div class="title">理念</div>
      <div class="desp">
        <p>東部是台灣最後的淨土，更是一塊等待精心雕琢的瑰寶，以期產生燦爛奪目的光華。和平電力公司，自許是道地的東部人，百分百從東部人的角度出發。因為有心手相連、相濡以沫，才能實現共同的願景提供「穩定充足的電力」，一起打造東部的繁榮與成長，讓東部瑰寶後來居上，真正散發璀璨的光芒！</p>
        <p>因此和平電力秉持「同理心、關懷心、環保心」之經營理念，真誠實在將穩定充足的電力傳送到東部每個地方、每個角落。和平電力帶來希望的火炬」，是推動東部光明前程及提昇美好生活品質，真愛真情的具體展現。</p>
      </div>
    </div>
  </section> -->
  <!-- <section class="sect"> -->
    <!-- <div class="performance"  style="display:none">
      <a class="item" href="">
        <div class="en">Certification</div>
        <i class="fa-solid fa-check"></i>
        <div class="tit">ISO認證</div>
      </a>
      <a class="item" href="">
        <div class="en">Power</div>
        <i class="fa-solid fa-bolt"></i>
        <div class="tit">電力報告</div>
      </a>
      <a class="item" href="">
        <div class="en">Environment</div>
        <i class="fa-brands fa-envira"></i>
        <div class="tit">環境監測</div>
      </a>
    </div> -->
  <!-- </section> -->
  <!-- <HelloWorld msg="ABC" /> -->
  <!-- <br><br><br><br><br>
  <br><br><br><br><br>
  <br><br><br><br><br>
  <br><br><br><br><br> -->  
  <Footer from="index" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Header from './../../components/Header.vue';
import Footer from './../../components/Footer.vue';
import HelloWorld from './../../components/HelloWorld.vue';
import HomeCarousel from './../../components/HomeCarousel.vue';

export default defineComponent({
  name: 'Index',
  components: {
    Header,
    Footer,
    HelloWorld,
    HomeCarousel
  },
  data() {
    return {
      arr: [1, 2, 3, "X", "Y", "Z"],
      blog: [
        {
          tit: "港電廠三合一導覽",
          brief: "在和平往和中的路旁，一不小心就錯過的路口，還得底盤較高的車輛才開得進去，挑戰一段充滿大小石礫的產業道路後，不小心還會遇到蹣跚漫步的黃牛，直到車子無法再前進，才抵達通往和平勇士山的「登山口」。勉為其難稱為「登山口」，因為如果沒有當地的部落小勇士帶領，恐怕無緣這趟秘境之旅。",
          thumbnail: "./social/03/thumbnail.jpg"
        },
        {
          tit: "和平的山之巔與海之涯 - 尋找勇士山神木、和中海灘",
          brief: "和平，位於花蓮最北邊，承載著人與山海間互相依存的美好關係，靜靜地守護著往來宜蘭花蓮的旅人們。",
          thumbnail: "./social/02/thumbnail.jpg"
        },
        {
          tit: "和平幸福巴士 - 乘載人情的部落另類風景",
          brief: "清晨的陽光照進和平街道，村子逐漸甦醒活動起來，而村辦公室前一部彩繪太魯閣族風情的<和平幸福巴士>正準備發動，開始一天的忙碌穿梭。",
          thumbnail: "./social/01/thumbnail.jpg"
        }
      ] 
    }
  },
  methods: {
    add(a:number, b:number): number {
      return a+b;
    },
    // setThumbnail: function(thumbnail: string) {
    //   return {
    //     background: "url(" + thumbnail + ") center", 
    //     backgroundSize: "cover"
    //   }
    // },
    // setBrief: function(brief: string) {
    //   return brief.substr(0, 58) + " ... <span class='more'>more</span>";
    // }
  },
  mounted() {
    let a: number = 1;
    let b: number = 2;
    let c = this.add(a, b);
    let rest: string[] = ["X", "Y"];
    // alert(c);
    // let arr: [number, string, any] = [1,"2", rest];
    let arr: string[] = ["1","2", ...rest];
    // console.log("arr = " + arr);

    interface face {
      id: number,
      tit: string,
    }

    let items: face[] = [
      {
        id: 1,
        tit: "AAA"
      },
      {
        id: 2,
        tit: "BBB"
      }
    ]
    console.log("ItemTit = " + items[1].tit);
  }
});
</script>

<style scoped>
#app-index {
  /* text-align: center; */
}

.sect {
  padding: 60px 0;
  box-sizing: border-box;
}

.sect .sectTitle {
  margin: 0 0 20px;
  letter-spacing: 2px;
  text-align: center;
  /* font-weight: bold; */
  font-size: 40px;
}

.blog {
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
}

.blog .item {
  flex: 0 0 31%;
  padding: 15px;
  box-sizing: border-box;
  border: solid 1px #e0e0e0;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  color: #303030;
}

.blog .item .thumbnail {
  height: 250px;
}

.blog .item .tit {
  height: 55px;
  margin: 10px 0 5px;
  text-align: left;
  font-weight: bold;
  font-size: 18px;
}

.blog .item .brief {
  height: 65px;
  border-top: dotted 2px #e0e0e0;
  padding: 10px 0 0;
  /* background: #ccc; */
}

.blog .item .brief .more {
  color: #0088ff;
}

.sectConcept {
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0) 20%, rgba(0, 32, 64, 0.8) 80%), url(./../../assets/index/concept.jpg);
  background-attachment: fixed;
  background-position: right center;
  background-size: cover;
}

.concept {
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: flex-end;
  color: #fff;
  text-shadow: 0 0 1px #000, 0 0 3px #000, 1px 1px 5px #000;
}

.concept .title {
  margin: 45px 30px;
  padding: 0 10px;
  box-sizing: border-box;
  border-right: solid 1px #fff;
  writing-mode: vertical-rl;
  letter-spacing: 5px;
  font-size: 60px;
}

.concept .desp {
  flex: 0 0 35%;
}

.concept .desp p {
  /* width: 35%; */
  margin: 40px 0;
  letter-spacing: 1px;
  line-height: 2em;
  font-size: 20px;
  text-shadow: 0 0 1px #fff, 0 0 3px #000, 1px 1px 5px #000;
}

.performance {
  /* width: 1200px; */
  margin: auto;
  display: flex;
  justify-content: space-around;
  /* border-top: solid 2px #fff; */
  /* border-bottom: solid 2px #fff; */
}

.performance .item {
  flex: 0 0 33.33%;
  overflow: hidden;
  position: relative;
  text-align: center;
  font-size: 60px;
}

.performance .item:nth-child(1) {
  padding: 60px 0;
  box-sizing: border-box;
  /* border-bottom: solid 5px #0088ff; */
  color: #0088ff;
  background: rgba(0, 136, 255, 0.2);
}

.performance .item:nth-child(2) {
  padding: 60px 0;
  box-sizing: border-box;
  /* border-bottom: solid 5px #ff7f27; */
  color: #ff7f27;
  background: rgba(255, 127, 39, 0.2);
}

.performance .item:nth-child(3) {
  padding: 60px 0;
  box-sizing: border-box;
  /* border-bottom: solid 5px #5eac85; */
  color: #5eac85;
  background: rgba(94, 172, 133, 0.2);
}

.performance .item .en {
  position: absolute;
  right: -10px;
  bottom: -20px;
  font-weight: bold;
  font-size: 80px;
  color: rgba(255, 255, 255, 0.5);
}

.performance .item i {
  text-shadow: 0 0 5px #fff,
               0 0 10px #fff,
               0 0 15px #fff,
               0 0 20px #fff;
}

.performance .item .tit {
  margin: 5px 0 0;
  position: relative;
  letter-spacing: 5px;
  font-weight: bold;
  font-size: 24px;
}
</style>
